import { render, staticRenderFns } from "./lkuPipaccount.vue?vue&type=template&id=482177f0"
import script from "./lkuPipaccount.vue?vue&type=script&lang=js"
export * from "./lkuPipaccount.vue?vue&type=script&lang=js"
import style0 from "./lkuPipaccount.vue?vue&type=style&index=0&id=482177f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports